import { render, staticRenderFns } from "./RichSearchSelect.vue?vue&type=template&id=71185120"
import script from "./RichSearchSelect.vue?vue&type=script&lang=js"
export * from "./RichSearchSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports